import Button from "./Button";
import React, { useEffect, useState } from "react";
import { useReducer } from "react";
import { reducer,initialState } from "../reducers/reducers";
import '../App.css'; // Optional: If you're using an external CSS file
import EditText from "./EditText";
import API_URLS from "../Urls";
import { AuthProvider, useAuth } from "./AuthProvider";
const EditInventoryQuantity = ({item,onCancel,onAccept}) => {
    const {user} = useAuth(); 
    const [state, dispatch] = useReducer(reducer, initialState);
    const [quantity,setQuantity] = useState(1)
    useEffect(()=>{
        if(item.cantidad!='No especificado')
            setQuantity(item.cantidad)
    },[])
    const postData = (url, dataToSend, onSuccesful) => {
        console.log("Posting to URL:", url); // Check URL during each post
        console.log("Data to send:", dataToSend);

        fetch(url, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(dataToSend)
        })
        .then(response => {
            if (!response.ok) throw new Error('Network response was not ok ' + response.statusText);
            return response.json();
        })
        .then(data => {
            if (typeof onSuccesful === 'function') onSuccesful(data);
            console.log(data);
        })
        .catch(error => console.error('There was a problem with the fetch operation:', error));
    };
    const putData = (url, dataToSend, onSuccesful) => {
        console.log("Puting to URL:", url); // Check URL during each post
        console.log("Data to send:", dataToSend);

        fetch(url, {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(dataToSend)
        })
        .then(response => {
            if (!response.ok) throw new Error('Network response was not ok ' + response.statusText);
            return response.json();
        })
        .then(data => {
            if (typeof onSuccesful === 'function') onSuccesful(data);
            console.log(data);
        })
        .catch(error => console.error('There was a problem with the fetch operation:', error));
    };
  
    return(
        <div className="modal-overlay">
        <div className="confirm-modal">
            Introduce la nueva cantidad
            <div className="invisible-horizontal-container">
            <input
            type="number"
            min={1}
            max={100}
            defaultValue={1}
            value={quantity || ''}
            onChange={(data) => {
                const value = data.target.value;

                // Limitar a 3 caracteres y solo números
                if (value.length <= 3 && /^\d*$/.test(value)) {
                const numericValue = parseInt(value, 10);

                // Asegurarse de que el valor esté dentro del rango permitido
                if (!isNaN(numericValue) && numericValue >= 1 && numericValue <= 100) {
                    setQuantity(numericValue)
                } else if (value === '') {
                    setQuantity(0)
                }
                }
            }}
            />
            </div>
            
            <div className="invisible-horizontal-container">
                
                <Button text="Aceptar" onClick={()=>{
                    
                    var dataToSend = {id:item.id_inventario,actualizacion_hecha_por:user['usuario'],id_producto:item.id,tipo_producto:item.tipo,cantidad:quantity};
                    console.log(dataToSend)
                    if(item.method == 'POST'){
                        postData(API_URLS.INVENTORY,dataToSend,()=>onAccept())
                    }
                    else {
                        putData(API_URLS.INVENTORY,dataToSend,()=>onAccept())
                    }
                  
                }} color="#7AACE3"></Button>
                <Button text="Cancelar" onClick={()=>onCancel()}></Button>
            </div>
        </div>
        </div>
    )
}
export default EditInventoryQuantity;